import React from "react";
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import styles from "./whatsnew.module.scss";
import cx from "classnames";

export default function Whatsnew() {

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const mainTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: "#astro",
          scrub: true,
          end: "+=750",
        },
      });
    const astroTimeline = gsap.timeline();
    astroTimeline.from("#astrowrapper",{
      y: 350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const moonTimeline = gsap.timeline();
    moonTimeline.from("#moonwrapper",{
      y: 350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const cloud1Timeline = gsap.timeline();
    cloud1Timeline.from("#cloud1wrapper",{
      x: -350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const cloud2Timeline = gsap.timeline();
    cloud2Timeline.from("#cloud2wrapper",{
      x: 350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const kiteTimeline = gsap.timeline();
    kiteTimeline.from("#kitewrapper",{
      x: 350,
      y: 350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const birdTimeline = gsap.timeline();
    birdTimeline.from("#birdwrapper",{
      x: -350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    const butterflyTimeline = gsap.timeline();
    butterflyTimeline.from("#butterflywrapper",{
      x: 350,
      y: 350,
      duration: 90,
      opacity: 0.8,
      delay: 4,
    });

    mainTimeline.add(astroTimeline, 12);
    mainTimeline.add(moonTimeline, 12);
    mainTimeline.add(cloud1Timeline, 12);
    mainTimeline.add(cloud2Timeline, 12);
    mainTimeline.add(kiteTimeline, 12);
    mainTimeline.add(birdTimeline, 12);
    mainTimeline.add(butterflyTimeline, 12);

  }, []);

  return (
    <>
      <div className={styles.contentWrapper}>
        <div className={styles.textSection}>
          <h2 className={styles.heading}>What’s new in cleverstory?</h2>
          <p className={cx(styles.paragraph)}>
            JANUARY, 2026
            <br />
            <br />
            Packed with all you’ll need for outer space where everything just
            falls in place
          </p>
        </div>

        <div className={styles.featuresSec}>
          <div className={styles.columnOne}>
            <div className={styles.featuresList}>
              <div className={styles.feature}>
                <div className={styles.feartureImg}>
                  <img src="/images/features/gating.png" />
                </div>
                <div className={styles.description}>
                  <h5> Exit-Intent Gating </h5>
                  <p>
                    Know when someone's about to bail and give them a reason to stay. That visitor who read everything but didn't convert? Catch them at the door with a form, discount, or demo offer. Way better than watching your best traffic leave empty-handed. 
                  </p>
                </div>
              </div>

              <div className={styles.feature}>
                <div className={styles.feartureImg}>
                  <img src="/images/features/lockWidget.png" />
                </div>
                <div className={styles.description}>
                  <h5> Widget Lock </h5>
                  <p>
                    Lock the stuff that shouldn't change, let your team edit everything else. You pick what stays protected (hero sections, legal copy, brand messaging). Everyone else can  work freely around protected elements, ensuring your brand story stays intact.
                  </p>
                </div>
              </div>

              <div className={styles.feature}>
                <div className={styles.feartureImg}>
                  <img src="/images/features/frames.png" />
                </div>
                <div className={styles.description}>
                  <h5> Frames </h5>
                  <p>
                    Sections that move together, stay together. Group them into blocks you can drag, duplicate, or save as templates. Rearrange your whole layout with one move instead of rebuilding the same thing over and over. You'll never have to recreate that three-section design again.
                  </p>
                </div>
              </div>

              <div className={styles.feature}>
                <div className={styles.feartureSeekImg}>
                  <img src="/images/features/seekWidget.png" />
                </div>
                <div className={styles.description}>
                  <h5> Seek </h5>
                  <p>
                    Unlock intelligent content discovery with our generative AI assistant. SEEK summarizes content hubs, answers specific questions, and extracts key insights from text and video, making your content instantly searchable and accessible 
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.whatsNewFooter}>
              <div className={styles.line}></div>
              <p className={styles.paragraph}>
              Want to master these powerful features? 
              <br />
              Visit our 
              <a href="https://experiences.cleverstory.io/cleverstory-academy?utm_source=fallinlove&utm_medium=lp" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold', color: 'black', textDecoration: 'underline', padding: '5px' }}>
                Cleverstory Academy
              </a>to learn how to leverage them for creating truly exceptional content experiences.
              </p>
            </div>
          </div>
          <div className={styles.columnTwo} id="astro">
            <div className={styles.astronaut}>
              <img id="astrowrapper" src="/images/astronaut2.png" />
            </div>
            <div className={styles.moon} >
              <img id="moonwrapper" src="/images/moon.png" />
            </div>
            <div className={styles.cloud1} >
              <img id="cloud1wrapper" src="/images/cloud1.png" />
            </div>
            <div className={styles.cloud2} >
              <img id="cloud2wrapper" src="/images/cloud2.png" />
            </div>
            <div className={styles.kite} >
              <img id="kitewrapper" src="/images/kite.png" />
            </div>
            <div className={styles.bird} >
              <img id="birdwrapper" src="/images/bird.png" />
            </div>
            <div className={styles.butterfly} >
              <img id="butterflywrapper" src="/images/butterfly.png" />
            </div>
          </div>
        </div>
        {/* <div className={styles.leafImg}>
          <img src={leaf} />
        </div> */}
      </div>
    </>
  );
}
